if (process.env.NODE_ENV === 'development') {
  /* eslint-disable global-require */
  require('react-hot-loader/patch');
}
require('babel-polyfill');
require('isomorphic-fetch');
/* eslint-enable global-require */



// WEBPACK FOOTER //
// ./book/src/polyfills.js